import * as fundebug from 'fundebug-javascript';
const isErr = (err: any) =>
  err instanceof Error || (err && err.stack && err.message && err.name);

export const initMonitor = () => {
  Error.stackTraceLimit = 30;

  fundebug.init({
    apikey: 'd4d7a40477328e940b8a69d14c5b6dac79a580ac1063fde8debd23fbae41c0a1',
  });

  const originalError = console.error;
  console.error = (...args: any[]) => {
    originalError(...args);
    for (const it of args) {
      if (isErr(it)) {
        fundebug.notify(it.name, it.message);
      }
    }
  };
};
